import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Nav, Loader, Button } from "ui-kit-ck-consultant";
import { Row, Col } from "react-flexbox-grid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLockOpen, faLock } from "@fortawesome/free-solid-svg-icons";

import Folder from "../../components/folder/Folder";
import Contact from "../../components/folder/Contact";
import Picture from "../../components/folder/Picture";
import Record from "../../components/folder/Record";
import Historical from "../../components/folder/Historical";

import axiosConfig from "../../utils/axiosConfig";

const Home = ({ refWebRTC }) => {
  const { token } = useParams(); // Remplace this.props.match.params.token
  const navigate = useNavigate();

  const [isLoad, setIsLoad] = useState(true);
  const [isLoadPictures, setIsLoadPictures] = useState(true);
  const [folderData, setFolderData] = useState({});
  const [pictures, setPictures] = useState([]);
  const [isLoadRecords, setIsLoadRecords] = useState(true);
  const [records, setRecords] = useState([]);
  const [historical, setHistorical] = useState([]);

  useEffect(() => {
    fetchFolder();
  }, []);

  const fetchFolder = (includePictures = true) => {
    setIsLoad(true);

    axiosConfig("folder/get-folder", { data: { token } })
      .then((res) => {
        if (res.data.success) {
          const { folder, historical } = res.data;
          setFolderData(folder);
          setHistorical(historical);
          setIsLoad(false);

          if (includePictures) fetchPictures(folder.id);
          fetchRecords(folder.id);
        } else {
          handleError("Erreur lors de la récupération du dossier.");
        }
      })
      .catch(() => handleError("Erreur lors de la récupération du dossier."));
  };

  const fetchPictures = (id) => {
    setIsLoadPictures(true);

    axiosConfig("folder/get-pictures", { data: { id } })
      .then((res) => {
        if (res.data.success) {
          setPictures(res.data.pictures);
          setIsLoadPictures(false);
        } else {
          handlePicturesError();
        }
      })
      .catch(handlePicturesError);
  };

  const handlePicturesError = () => {
    setIsLoadPictures(false);
    setPictures([]);
  };

  const fetchRecords = (id) => {
    setIsLoadRecords(true);

    axiosConfig("folder/get-records", { data: { id } })
      .then((res) => {
        setRecords(res.data.success ? res.data.records : []);
        setIsLoadRecords(false);
      })
      .catch(() => {
        setIsLoadRecords(false);
        setRecords([]);
      });
  };

  const deleteRecord = (id) => {
    setIsLoadRecords(true);

    axiosConfig("folder/delete-record", { data: { id } })
      .then((res) => {
        if (res.data.success) {
          setRecords((prev) => prev.filter((element) => element.id !== id));
        } else {
          alert("Erreur lors de la suppression de l'enregistrement.");
        }
        setIsLoadRecords(false);
      })
      .catch(() => {
        alert("Erreur lors de la suppression de l'enregistrement.");
        setIsLoadRecords(false);
      });
  };

  const handleError = (message) => {
    alert(message);
    setIsLoad(false);
    navigate("/home"); // Remplace this.props.history.push("/home")
  };

  const updateFolderStatus = (status) => {
    setIsLoad(true);

    axiosConfig("folder/update-status-folder", {
      data: { status, id: folderData.id },
    })
      .then((res) => {
        if (res.data.success) {
          setFolderData((prev) => ({ ...prev, status: res.data.status }));
          setIsLoad(false);
        } else {
          handleError("Erreur lors de la mise à jour du statut.");
        }
      })
      .catch(() => handleError("Erreur lors de la mise à jour du statut."));
  };

  return (
    <>
      <Nav
        title={`N° dossier ${folderData.reference}`}
        className="mb-10 mb-20-xl"
        back
        onBack={() => navigate("/home")} // Utilisation de useNavigate
      >
        {folderData.status >= 1 && folderData.status < 4 && (
          <Button
            className="ml-5"
            text="Clôturer"
            onClick={() => updateFolderStatus(4)}
          >
            <FontAwesomeIcon icon={faLock} />
          </Button>
        )}
        {folderData.status === 4 && (
          <Button
            className="ml-5"
            text="Rouvrir"
            onClick={() => updateFolderStatus(0)}
          >
            <FontAwesomeIcon icon={faLockOpen} />
          </Button>
        )}
      </Nav>

      <Row>
        <Col xs={12} md={6} lg={8} className="mb-10 mb-20-xl">
          <Folder {...folderData} getFolder={fetchFolder} />
        </Col>
        <Col xs={12} md={6} lg={4} className="mb-10 mb-20-xl">
          <Contact
            {...folderData}
            getFolder={fetchFolder}
            refWebRTC={refWebRTC}
          />
        </Col>
        <Col xs={12} className="mb-10 mb-20-xl">
          <Picture
            isLoad={isLoadPictures}
            data={pictures}
            folderId={folderData.id}
            deletePictures={(ids) => {
              setIsLoadPictures(true);
              axiosConfig("folder/delete-pictures", { data: { ids } })
                .then((res) => {
                  if (res.data.success) {
                    setPictures((prev) =>
                      prev.filter((p) => !ids.includes(p.id))
                    );
                  } else {
                    alert("Erreur lors de la suppression.");
                  }
                  setIsLoadPictures(false);
                })
                .catch(() => {
                  alert("Erreur lors de la suppression.");
                  setIsLoadPictures(false);
                });
            }}
            sendPicturesToGLA={(folderId, pictureIds) => {
              setIsLoadPictures(true);
              axiosConfig("folder/send-pictures-gla", {
                data: { folderId, pictureIds },
              })
                .then((res) => {
                  if (res.data.success) {
                    setPictures((prev) =>
                      prev.map((p) =>
                        pictureIds.includes(p.id)
                          ? { ...p, sentToGLA: 1 }
                          : p
                      )
                    );
                    alert(
                      `${res.data.sentCount} photo(s) envoyée(s) vers GLA SOFTWARE.`
                    );
                  } else {
                    alert(
                      res.data.message ||
                        "Erreur lors de l'envoi vers GLA SOFTWARE."
                    );
                  }
                  setIsLoadPictures(false);
                })
                .catch(() => {
                  alert("Erreur lors de l'envoi vers GLA SOFTWARE.");
                  setIsLoadPictures(false);
                });
            }}
          />
        </Col>
        <Col xs={12} className="mb-10 mb-20-xl">
          <Record
            data={records}
            isLoad={isLoadRecords}
            deleteRecord={deleteRecord}
          />
        </Col>
        <Col xs={12} className="mb-10 mb-20-xl">
          <Historical historical={historical} />
        </Col>
      </Row>

      <Loader show={isLoad} />
    </>
  );
};

export default Home;
